import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { ReactNode, useRef, useEffect, useState } from 'react'
import { authService } from '@/services/authService'
import ContractAgreementModal, { type ContractAgreementModalRef } from '@/components/modals/ContractAgreementModal'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, user, logout, updateUser } = useAuth()
  const contractModalRef = useRef<ContractAgreementModalRef>(null)
  const [hasCheckedContract, setHasCheckedContract] = useState(false)

  // Check if user needs to agree to contract
  useEffect(() => {
    if (isAuthenticated && user && !hasCheckedContract) {
      // Check if contract_agreement is null or undefined (not yet agreed)
      const needsToAgree = !user.contract_agreement

      if (needsToAgree) {
        contractModalRef.current?.open()
      }

      setHasCheckedContract(true)
    }
  }, [isAuthenticated, user, hasCheckedContract])

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  const handleAgreeContract = async () => {
    // Call agreeContract which will automatically fetch updated profile
    const updatedUser = await authService.agreeContract()
    // Update user state in context
    updateUser(updatedUser)
  }

  const handleDeclineContract = () => {
    logout()
  }

  return (
    <>
      {children}
      <ContractAgreementModal
        ref={contractModalRef}
        onAgree={handleAgreeContract}
        onDecline={handleDeclineContract}
      />
    </>
  )
}
